import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SearchBar extends Vue {
  @Prop({ default: '' })
  public readonly placeholder!: string;

  public search = '';
}
